import React from "react";

function Mcpsj(){
    return <>
        mcp上架
    </>
}

export default Mcpsj